<template>
  <div class="my-table userPage">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('userManagement.txt1')}}</span>
        <span>{{$t('userManagement.txt2')}}</span>
      </div>
      <div class="flexEnd">
        <div class="handleBoxSeach flexCenter w350">
          <el-input
            :placeholder="$t('userManagement.txt3')"
             v-model="queryInfo.search" @keypress.native.enter="loadData">
            <img slot="prefix" class="searchIcon" src="@/assets/picture/icon/search_icon.png">
          </el-input>
          <div class="searchBtn" @click="loadData">{{$t('userManagement.txt4')}}</div>
        </div>
        <el-upload
        :headers="importHeaders"
          class="avatar-uploader"
          action="apiUrl + '/user/info/import'"
          :show-file-list="false"
          :on-exceed="handleAvatarExceed"
          :on-success="handleAvatarSuccess">
          <div class="searchBtn ml20" @click="handleUpload">{{$t('userManagement.txt5')}}</div>
        </el-upload>
        <div class="searchBtn ml20" @click="handleDownload">{{$t('userManagement.txt6')}}</div>
        <div class="searchBtn ml20" @click="handleAdd">{{$t('userManagement.txt7')}}</div>
      </div>
    </div>
     <!--  <div class="fr rightBox">
        <div class="searchSubBox flex">
          <div class="flex searchSubBox">
            <span class="labelTxt">手机号:</span>
            <el-input v-model="queryInfo.mobile" placeholder="请输入"></el-input>
          </div>
          <div class="flex searchSubBox">
            <span class="labelTxt">用户名:</span>
            <el-input v-model="queryInfo.userName" placeholder="请输入"></el-input>
          </div>
          <div class="flex searchSubBox">
            <span class="labelTxt">真实姓名:</span>
            <el-input v-model="queryInfo.realName" placeholder="请输入"></el-input>
          </div>
          <div class="btnC activedBtn" @click="handleSearch">
            <span class="btn-txt">查询</span>
          </div>
        </div>
      </div> -->
    <!-- </div> -->
    <!-- 面包屑 -->
    <el-card class="tableCard">
      <el-table :data="dataList" v-loading="loading" :default-sort = "{prop: 'projName', order: 'descending'}">
          <el-table-column
            :label="$t('userManagement.txt8')"
            type="index"
            width="50">
          </el-table-column>
          <el-table-column :label="$t('userManagement.txt9')">
            <template slot-scope="scope">
              <span>{{scope.row.userName?scope.row.userName:'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('userManagement.txt10')" >
            <template slot-scope="scope">
              <span>{{scope.row.realName?scope.row.realName:'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('userManagement.txt11')" >
            <template slot-scope="scope">
              <span>{{scope.row.mobile?scope.row.mobile:'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('userManagement.txt12')" width="200">
            <template slot-scope="scope">
              <span>{{scope.row.email?scope.row.email:'--'}}</span>
            </template>
          </el-table-column>
         <!--  <el-table-column label="单位名称" >
            <template slot-scope="scope">
              <span>{{scope.row.companyName?scope.row.companyName:'--'}}</span>
            </template>
          </el-table-column> -->
          <el-table-column :label="$t('userManagement.txt13')" >
            <template slot-scope="scope">
              <span v-if="scope.row.roleList[0]">{{scope.row.roleList[0].roleName}}</span>
              <span v-if="scope.row.roleList[1]">,{{scope.row.roleList[1].roleName}}</span>
              <span v-if="scope.row.roleList.length>2">...</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('userManagement.txt14')" width="100">
            <template slot-scope="scope">
              <span>{{scope.row.expiredDate | formatDate}}</span>
              <!-- <span class="ml2" v-if="scope.row.enable == 1">到期</span> -->
            </template>
          </el-table-column>
          <el-table-column  :label="$t('userManagement.txt15')" width="430">
            <template slot-scope="scope">
              <el-button @click="handleEditPassword(scope.row)" class="handleBtn" type="text">{{$t('userManagement.txt16')}}</el-button>
              <el-button @click="handleEditRole(scope.row)" class="handleBtn" type="text">{{$t('userManagement.txt17')}}</el-button>
              <el-button @click="handleDelete(scope.row)" class="handleBtn" type="text">{{$t('userManagement.txt18')}}</el-button>
              <div class="btnC activedBtn ml2" v-if="scope.row.enable == 1">
                <span @click="handleActivation(2,scope.row.id)" class="btn-txt">{{$t('userManagement.txt19')}}</span>
              </div>
              <div class="btnC addBtn ml2" v-if="scope.row.enable == 2">
                <span @click="handleFrozen(1,scope.row.id)" class="btn-txt">{{$t('userManagement.txt20')}}</span>
              </div>
            </template>
          </el-table-column>
      </el-table>    
    </el-card>
    <div class="table-footer tablePagination" v-show="total>0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pageNum"
        :page-sizes="[10, 20, 30, 40]"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
    <!-- 激活 -->
    <el-dialog :title="$t('userManagement.txt19')" :visible.sync="dialogFormActivationVisible" :closeOnClickModal="false">
      <el-form :model="activationForm" :rules="activationRules" ref="activationForm" label-width="100px" class="demo-ruleForm">
        <el-form-item :label="$t('userManagement.txt21')" prop="effectDate">
          {{activationForm.effectDae}}
          <el-date-picker
            v-model="activationForm.effectDate"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="-"
            :start-placeholder="$t('userManagement.txt22')"
            :end-placeholder="$t('userManagement.txt23')">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="confirmbtn" @click="confirmActivation('activationForm')">{{$t('userManagement.txt24')}}</el-button>
        <el-button class="cancelbtn" @click="resetActivation('activationForm')">{{$t('userManagement.txt25')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {apiUrl, serverUrl} from '@/utils/request';
  let mytoken = window.sessionStorage.getItem("token");
  import { formatDate } from "@/plugins/date.js";
  import { crytoLogin } from "@/plugins/index.js";
  import axios from "axios";
  import qs from 'qs';
  export default {
    data() {
      return {
        loading: false,
        importHeaders: {'Authorization': mytoken},
        isIndeterminate: true,
        time:'',
        dialogFormActivationVisible:false,//激活弹出框
        fromData:{},//分享参数
        addUserForm:{},//添加用户参数
        activationForm:{
          effectDate:'',
        },
        //用于获取数据列表
        queryInfo: {
          pageNum: 1,
          size: 10,
          search: ''
        },
        dataList: [],
        total: 0,
        validityDate:[],//有效期数组
        addUserFromData:{
          roleId:window.sessionStorage.getItem("roleId"),
        },//用户新增表单参数
        // 激活规则
        activationRules: {
          effectDate: [
            { required: true, message: this.$t('userManagement.txt26'), trigger: 'change' },
          ],
        },
      };
    },
    created() {
      this.loadData();
    },
    filters: {
      formatDate(time) {
        var date = new Date(time);
        return formatDate(date, "yyyy-MM-dd");
      },
    },
    methods: {
      // 数据加载(用户管理列表)
      async loadData(){
        this.loading = true;
        const { data: res } = await this.$http.post("/user/info/list?"+qs.stringify({...this.queryInfo, pageNum: this.queryInfo.pageNum - 1}));
        this.loading = false;
        if(!res.success){
          return this.$message.error(res.message);
        }
        this.dataList = res.result.data;
        this.total = res.result.total;
      },
      // 导入用户
      handleUpload(){

      },
      // 导出模板
      async handleDownload(){
        return axios({
           url: "/user/info/template/download",
           method: 'get',
           responseType: 'blob',
           headers: {
               'Content-Type': 'application/json'
           }
       })
        .then(res => {
            const blob = new Blob([res.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            // 语言包todo
            const fileName = '用户列表.xlsx';
            const linkNode = document.createElement('a');
            linkNode.style.display = 'none';
            linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
            document.body.appendChild(linkNode);
            linkNode.click(); //模拟在按钮上的一次鼠标单击
            URL.revokeObjectURL(linkNode.href); // 释放URL 对象
            document.body.removeChild(linkNode);

        })
        .catch((err) => {
            console.log(err);
        });
      },
      // handleAvatarExceed(files, fileList) {
      //   this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件，请删除后上传`);
      // },
       handleAvatarExceed(files, fileList) {
         this.$message.warning(this.$t('editTask.txt18')+files.length);
      },
      handleAvatarSuccess(res, file) {
        if(!res.success){
          return this.$message.error(res.message);
        }
        this.loadData();
        this.$message({
          type: 'success',
          message: this.$t('userManagement.txt29')
        });
      },
      // 修改角色
      handleEditRole(row){
        this.$router.push("/userEditRole?id=" + row.id+"&roleIds="+row.roleList[0].id);
      },
      // 修改密码操作
      handleEditPassword(row){
        this.$router.push("/userEditPassword?id=" + row.id);
        // this.editPasswordForm.id = row.id;
        // this.dialogFormEditPasswordVisible = true;
      },
      // 数据加载(用户管理列表)
      async password(){
        let data = {
          id:this.editPasswordForm.id,
          password:crytoLogin(this.editPasswordForm.password).rsaData,
        }
        const { data: res } = await this.$http.post("/user/info/change/password?"+qs.stringify(data));
        if(!res.success){
          return this.$message.error(res.message);
        }
        this.dialogFormEditPasswordVisible = false;
        this.$message({
          message: res.message,
          type: 'success'
        });
      },
      // 删除
      handleDelete(row){
        let id = row.id;
        this.$confirm('<p class="color666 fz14">'+this.$t('userManagement.txt30')+'</p><p class="color999 fz14">'+this.$t('userManagement.txt31')+'</p>', this.$t('userManagement.txt18'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('userManagement.txt24'),
          cancelButtonText: this.$t('userManagement.txt25'),
          type: 'warning',
          center: true
        }).then(() => {
          this.deleteUser(id);    
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('userManagement.txt32')
          }); 
        });
      },
      // 用户管理删除
      async deleteUser(id){
        let data = {
          id:id
        }
        const { data: res } = await this.$http.post("/user/info/delete?"+qs.stringify(data));
        if(!res.success){
          return this.$message.error(res.message);
        }
        this.$message({
          message: res.message,
          type: 'success'
        });
        this.loadData();
      },
      // 激活
      handleActivation(statusType,idData){
        this.$router.push("/userActivation?id=" + idData);
        // this.activationForm = {};
        this.activationForm.id = idData;
        // this.activationForm.effectDate = '';
      },
      // 确认激活
      confirmActivation(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let id = this.activationForm.id;
           this.freeze(2,id);
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetActivation(formName) {
        this.$refs[formName].resetFields();
        this.dialogFormActivationVisible = false;
      },
      // 冻结
      handleFrozen(statusType,idData){
        let status = statusType;
        let id = idData;
        this.$confirm('<p class="color666 fz14">'+this.$t('userManagement.txt33')+'</p><p class="color999 fz14">'+this.$t('userManagement.txt34')+'</p>', this.$t('userManagement.txt35'), {
          dangerouslyUseHTMLString: true,
          cancelButtonText: this.$t('userManagement.txt25'),
          confirmButtonText: this.$t('userManagement.txt24'),
          type: 'warning',
          center: true
        }).then(() => {
          this.freeze(status,id);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('userManagement.txt31')
          });          
        });
      },
      // 用户新增
      handleAdd(){
        this.$router.push("/userEdit");

      },
      // 用户冻结/解冻
      async freeze(statusType,idData){
        let data = {};
        if(statusType == 2){
          data = {
            freeze:statusType,
            id:idData,
            startDate:this.activationForm.effectDate[0],
            endDate:this.activationForm.effectDate[1],
          }
        }else{
          data = {
            freeze:statusType,
            id:idData
          }
        }
        const { data: res } = await this.$http.post("/user/info/freeze?"+qs.stringify(data));
        if(!res.success){
          return this.$message.error(res.message);
        }
        this.dialogFormActivationVisible = false;
        if(statusType == 1){
          this.$message({
            type: 'success',
            message: this.$t('userManagement.txt36')
          });
        }else{
          this.$message({
            type: 'success',
            message: this.$t('userManagement.txt37')
          });
        }
        this.loadData();
      },
      // 搜索
      handleSearch(){
        this.queryInfo.pageNum = 1;
        this.queryInfo.size = 10;
        this.loadData();
      },
      // 编辑/详情
      handleDetail(row,type){
        this.$router.push({path: "/sceneRecordDetail",query: {type: type,id: row.id}});
      },
      // 页面切换
      handleCurrentChange(page) {
        this.queryInfo.pageNum = page;
        this.loadData();
      },
      handleSizeChange(size){
        this.queryInfo.size = size;
        this.loadData();
      },
    },
  };
</script>

<style lang="less" scoped>

  .handleBtn{
    padding: 0;
    margin-right: 20px !important;
  }
  .handleBtn:last-of-type{
    margin: 0 !important;
  }
  .userPage{
    .el-button+.el-button{
      margin: 0;
    }
    .btn-txt{
      padding:8px 20px !important;
      display: block;
      border-radius: 30px;
    }
    .activedBtn{
      border-radius: 30px;
      border: none;
    }
    .addBtn{
      border-radius: 30px;
      border: 1px solid #1B3B7C;
    }
    /deep/ .el-upload__input{
      display: none !important;
    }
    /deep/ .el-date-editor .el-range-separator{
      margin-top: -5px;
      width: 8%;
    }
    .w350{
      width: 350px;
    }
    .searchUserBox{
      /*width: 33.6rem !important;*/
      height: 3.2rem;
      margin-bottom: 3rem;
      /deep/ .el-input__inner{
        border:1px solid #C0C0C0;
        border-right:none;
      }
      /deep/ .el-input-group__append{
        border:1px solid #C0C0C0;
        border-left:none;
        padding:0;
        background: #fff;
      }
      /deep/ .el-input-group__append button.el-button{
        padding:0;
        width: auto;
        margin-right: 1.1rem;
      }
    }
    .tips{      
      font-size: 1.4rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #98B9FF;
      margin-top: -10px;
    }
    /deep/ .el-dialog{
      /deep/ .el-input,/deep/ .el-input__inner{
        width: 100% !important;
      }
      /deep/ .el-form-item:first-of-type,/deep/ .el-form-item:last-of-type{
        margin-bottom: 0;
      }
      /deep/ .el-dialog .el-dialog__body .el-select .el-input__inner, .el-dialog .el-dialog__body .el-input__inner, .el-dialog .el-dialog__body .el-input{
        border-radius: 8px; 
      }
    }
  }

</style>
